import Joi from 'joi';

import { SintomasSliderProps } from './models';

const stringRequired = Joi.string().required();

const itemSchema = Joi.object({
  name: stringRequired,
  alt: stringRequired,
  mainImage: stringRequired,
  flipImage: stringRequired,
  ataque: stringRequired,
  molestia: stringRequired,
  debilidad: stringRequired,
});

const requiredItemSchema = Joi.array().items(itemSchema).min(1).required();

export const SintomasSliderSchema = Joi.object<SintomasSliderProps>({
  items: requiredItemSchema,
});
